import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Icon from '../forms/icon.component';

interface StatItem {
  label: string;
  value: number | string;
  icon: string;
  bgColor?: string;
  textColor?: string;
}

interface ModuleStatsHeaderProps {
  stats: StatItem[];
  datePicker?: React.ReactNode;
  onRefresh?: () => void;
  isLoading?: boolean;
  extraActions?: React.ReactNode;
}

const ModuleStatsHeader: React.FC<ModuleStatsHeaderProps> = ({
  stats,
  datePicker,
  onRefresh,
  isLoading,
  extraActions
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-0">
      <div className="d-flex flex-row flex-wrap align-items-center justify-content-between gap-4">
        <div className="d-flex flex-wrap align-items-center gap-3 gap-xl-8">
          {stats.map((item, index) => (
            <div key={index} className="d-flex align-items-center gap-3">
              <div
                className={`d-flex align-items-center justify-content-center rounded-circle ${item.bgColor || 'bg-light-primary'}`}
                style={{ width: 42, height: 42 }}
              >
                <Icon icon={item.icon} size="fs-4" />
              </div>
              <div className="d-flex flex-column">
                <span className="fs-7 fw-bolder">{item.label}</span>
                <motion.span
                  key={String(item.value)}
                  initial={{ filter: 'blur(8px)', opacity: 0 }}
                  animate={{ filter: 'blur(0px)', opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  className={`fw-bolder fs-3 ${item.textColor || ''}`}
                >
                  {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
                </motion.span>
              </div>
              {index !== stats.length - 1 && (
                <div className="d-none d-md-block border-end border-gray-300 h-35px ms-2 ms-xl-6 me-1 me-xl-2" />
              )}
            </div>
          ))}
        </div>
        <div className="d-flex flex-wrap align-items-center justify-content-start justify-content-md-end gap-3 ms-md-auto">
          {datePicker && datePicker}
          {onRefresh && (
            <div className="card shadow-sm border-0">
              <button
                className="btn d-flex align-items-center b-radius"
                onClick={onRefresh}
                disabled={isLoading}
              >
                <Icon icon="ki-abstract-20" size="fs-2" className="me-1" type="info" />
                {t('general.update')}
              </button>
            </div>
          )}
          {extraActions && extraActions}
        </div>
      </div>
    </div>
  );
};

export default ModuleStatsHeader;
